export * from './confirm/confirm.page';
export * from './contact/contact.page';
export * from './courses/courses.page';
export * from './error/error.page';
export * from './order/order.page';
export * from './payment/payment.page';
export * from './thanks/thanks.page';
